import { FilmProject } from '../types';

export function FilmCard(film: FilmProject): string {
  const tagsHtml = film.tags.map(tag => /*html*/`
    <span style="font-size: 0.72rem; padding: 0.2rem 0.5rem; border-radius: 4px; background: rgba(249, 115, 22, 0.12); color: #fb923c; border: 1px solid rgba(249, 115, 22, 0.25);">
      ${tag}
    </span>
  `).join('');

  return /*html*/`
    <div class="glass-panel" style="display: flex; flex-direction: column; overflow: hidden; height: 100%; border-top: 3px solid #f97316;">
      
      <!-- Video Thumbnail Frame -->
      <div style="position: relative; height: 200px; overflow: hidden; background: #000;">
        <img 
          src="${film.thumbnail}" 
          alt="${film.title}" 
          style="width: 100%; height: 100%; object-fit: cover; transition: transform 0.4s ease;"
          onmouseover="this.style.transform='scale(1.05)'"
          onmouseout="this.style.transform='scale(1.0)'"
        />
        <div style="position: absolute; top: 0.85rem; right: 0.85rem;">
          <span class="badge badge-orange">${film.category}</span>
        </div>
        <div style="position: absolute; inset: 0; background: linear-gradient(180deg, transparent 40%, rgba(7, 8, 13, 0.95) 100%);"></div>

        <div style="position: absolute; bottom: 0.85rem; left: 1rem; right: 1rem;">
          <div style="font-size: 0.78rem; color: #fb923c; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 0.2rem;">
            Premiere: ${film.releaseDate}
          </div>
          <div style="font-size: 0.85rem; color: #e2e8f0; font-style: italic; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            "${film.logline}"
          </div>
        </div>
      </div>

      <!-- Content -->
      <div style="padding: 1.5rem; display: flex; flex-direction: column; flex-grow: 1; justify-content: space-between;">
        <div>
          <h3 style="font-size: 1.2rem; font-weight: 700; color: #fff; margin-bottom: 0.6rem;">
            ${film.title}
          </h3>
          <p style="font-size: 0.88rem; color: #94a3b8; line-height: 1.6; margin-bottom: 1.25rem;">
            ${film.description}
          </p>

          <!-- Tags -->
          <div style="display: flex; flex-wrap: wrap; gap: 0.35rem; margin-bottom: 1.5rem;">
            ${tagsHtml}
          </div>
        </div>

        <!-- Action Links -->
        <div style="display: flex; gap: 0.5rem; flex-wrap: wrap; border-top: 1px solid rgba(255,255,255,0.06); padding-top: 1rem;">
          ${film.youtubeUrl ? /*html*/`
            <a href="${film.youtubeUrl}" target="_blank" rel="noopener noreferrer" class="btn-cyber" style="background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%); padding: 0.45rem 0.85rem; font-size: 0.82rem; flex-grow: 1;">
              <sl-icon name="youtube"></sl-icon>
              <span>Watch on YouTube</span>
            </a>
          ` : ''}

          ${film.tiktokUrl ? /*html*/`
            <a href="${film.tiktokUrl}" target="_blank" rel="noopener noreferrer" class="btn-ghost" style="padding: 0.45rem 0.85rem; font-size: 0.82rem; flex-grow: 1;">
              <sl-icon name="tiktok"></sl-icon>
              <span>TikTok Shorts</span>
            </a>
          ` : ''}
        </div>

      </div>

    </div>
  `;
}
